import {Tabs} from '@mui/material';
import React, {SyntheticEvent} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';

import Icon from 'presentation/icons';
import {useMediaQueries} from 'presentation/pages';
import {StickHeader, StyledTab, StyledTabsContainer} from './styles';
import {HeaderTabNavigationProps} from './types';

export function HeaderTabNavigation({
	tabs,
	variant = 'scrollable',
	customBackground,
	customTabProps,
	headerId,
	...tabsProps
}: HeaderTabNavigationProps) {
	const {pathname, state: routeState} = useLocation();
	const navigate = useNavigate();
	const {isMobile} = useMediaQueries();

	const handleChange = (_event: SyntheticEvent, newValue: string) => {
		navigate(newValue, {replace: true, state: routeState});
	};

	return (
		<StickHeader id={headerId} $background={customBackground}>
			<StyledTabsContainer>
				<Tabs
					scrollButtons="auto"
					allowScrollButtonsMobile
					value={pathname}
					onChange={handleChange}
					variant={variant}
					aria-label="auto tabs"
					{...tabsProps}>
					{tabs?.map(tab => (
						<StyledTab
							key={tab.name}
							id={tab.id}
							value={tab.route}
							label={tab.name}
							icon={tab.icon ? <Icon name={tab.icon} /> : undefined}
							iconPosition="start"
							$isMobile={isMobile}
							data-tag-id={tab.dataTagId}
							{...customTabProps}
						/>
					))}
				</Tabs>
			</StyledTabsContainer>
		</StickHeader>
	);
}
